import _ from 'lodash'
import DepartmentType from './DepartmenType'
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import {MediaObject} from '@/modules/media/types';

/**
 * Departamento
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class Department {
    public readonly tempId = _.uniqueId('department_')
    public id = 0
    public name = ''
    public capacity = 0
    public price = 0
    public shortDescription = ''
    public largeDescription = ''
    public type = new DepartmentType()
    public image = new MediaObject()
    public createdAt = new Date()
    public updatedAt = new Date()

    public get openingTime () {
        return this.type.openingTime
    }

    public get closingTime () {
        return this.type.closingTime
    }

    /**
     * Indica si la hora de cierre de departamento ocurre el día siguiente a la
     * hora de apertura
     */
    public get closesNextDay () {
        return this.type.closesNextDay
    }

    /**
     * Duración de las reservas para este departamento
     */
    public get duration () {
        return this.type.duration
    }

    /**
     * Indica si el departamento
     */
    public get isNew (): boolean {
        return !this.id
    }

    get departmentTypeId (): number {
        return this.type.id
    }

    public static deserialize (data: KeyValuePair) {
        const department = new this()
        department.id = data.id
        department.name = data.name
        department.capacity = data.capacity
        department.price = data.price
        department.shortDescription = data.short_description
        department.largeDescription = data.large_description
        department.type = DepartmentType.deserialize(data.type_department)
        department.image = MediaObject.convert(data.image || {})
        department.createdAt = new Date(data.created_at)
        department.updatedAt = new Date(data.updated_at)

        return department
    }

    public serialize (): KeyValuePair {
        return {
            id:  this.id,
            name: this.name,
            capacity: this.capacity,
            price: this.price,
            short_description: this.shortDescription,
            large_description: this.largeDescription,
            type: this.type.id,
            image: this.image ? this.image.id : null,
        }
    }
}
